export default function Footer() {
  return (
    <footer className="bg-navy text-white/70 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-[11px] tracking-[0.2em] uppercase font-semibold">
        <div className="flex items-center gap-3">
          <span className="inline-block w-2 h-2 bg-white" />
          <span>Peak Disposal · Central Alabama</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="tel:2059993399" className="hover:text-white transition-colors" data-testid="footer-phone">
            205 · 999 · 3399
          </a>
          <a href="mailto:peakdisposalal@gmail.com" className="hover:text-white transition-colors" data-testid="footer-email">
            Email
          </a>
        </div>
      </div>
    </footer>
  );
}
